<template>
  <div class="app vld-parent">
    <notifications group="app" position="top center">
      <template slot="body" slot-scope="props">
        <b-alert :variant="props.item.type" show class="m-2 text-center"
          >{{ props.item.text }}
        </b-alert>
      </template>
    </notifications>
    <AppHeader fixed class="vertical">
      <div class="header-content">
        <SidebarToggler
          v-if="layout.sidebar"
          class="d-lg-none"
          display="md"
          :default-open="false"
          mobile
        />
        <b-link
          v-if="(minimized && logoMinimized) || (!minimized && logo)"
          class="navbar-brand"
          to="/"
        >
          <img
            class="navbar-brand-full d-md-down-none"
            :src="logo"
            alt="Logo"
            crossorigin="anonymous"
          />
          <img
            class="navbar-brand-full d-lg-none"
            :src="logo"
            alt="Logo"
            crossorigin="anonymous"
          />
          <img
            class="navbar-brand-minimized"
            :src="logoMinimized"
            style="max-width: 50px; max-height: 40px"
            alt="Logo"
            crossorigin="anonymous"
          />
        </b-link>
        <div class="d-flex justify-content-between flex-grow-1">
          <b-navbar-nav
            class="header-nav d-md-down-none"
            style="padding-left: 64px"
          >
            <b-nav-item :to="followUpRoute" class="=mx-3">{{
              $t("home.btn.followup")
            }}</b-nav-item>
            <b-nav-item :to="'/' + Routes['report'][$i18n.locale]" class="mx-3">
              {{ $t("home.btn.report") }}
            </b-nav-item>
            <b-nav-item
              v-if="hasDocumentsSection"
              href="#leiturasImportantes"
              class="mx-3"
              >{{ $t("martinelli.container.documents") }}</b-nav-item
            >
          </b-navbar-nav>
          <b-navbar-nav class="header-nav d-md-down-none">
            <b-nav-item to="#ajuda" class="mx-3">
              {{ $t("martinelli.container.help") }}
              <i class="far fa-question-circle font-l" />
            </b-nav-item>
            <b-nav-item :href="adminUrl" class="mx-3">
              {{ $t("martinelli.container.admin") }}
              <i class="fas fa-lock font-l" />
            </b-nav-item>
            <LanguageSwitcher
              v-if="hasMultiLanguageSupport"
              :portal-languages="portal.languages"
            />
          </b-navbar-nav>
        </div>
      </div>
    </AppHeader>
    <div class="app-body vertical">
      <AppSidebar v-if="layout.sidebar" fixed>
        <SidebarHeader />
        <SidebarNav :nav-items="sidebarLinks"></SidebarNav>
        <SidebarFooter />
        <SidebarMinimizer @cui-sidebar-minimize="onMinimize" />
      </AppSidebar>
      <main class="main">
        <template v-if="loading">
          {{ $t("martinelli.container.loading") }}</template
        >
        <router-view v-else></router-view>
      </main>
    </div>
    <section id="ajuda">
      <h1 class="section-title">
        <span class="theme-color">{{
          $t("martinelli.faq.sectionTitleHighlight")
        }}</span>
        {{ $t("martinelli.faq.sectionTitle") }}
      </h1>
      <b-card no-body class="topic">
        <b-card-header>
          <b-button v-b-toggle="'topic1'" block>
            <h1>{{ $t("martinelli.faq.q1") }}</h1>
            <i class="fas fa-chevron-down" />
            <i class="fas fa-chevron-up" />
          </b-button>
        </b-card-header>
        <b-collapse id="topic1">
          <p>
            {{ $t("martinelli.faq.a1") }}
          </p>
        </b-collapse>
      </b-card>
      <b-card no-body class="topic">
        <b-card-header>
          <b-button v-b-toggle="'topic2'" block>
            <h1>{{ $t("martinelli.faq.q2") }}</h1>
            <i class="fas fa-chevron-down" />
            <i class="fas fa-chevron-up" />
          </b-button>
        </b-card-header>
        <b-collapse id="topic2">
          <p>
            {{ $t("martinelli.faq.a2") }}
          </p>
        </b-collapse>
      </b-card>
      <b-card no-body class="topic">
        <b-card-header>
          <b-button v-b-toggle="'topic3'" block>
            <h1>{{ $t("martinelli.faq.q3") }}</h1>
            <i class="fas fa-chevron-down" />
            <i class="fas fa-chevron-up" />
          </b-button>
        </b-card-header>
        <b-collapse id="topic3">
          <p>
            {{ $t("martinelli.faq.a3") }}
          </p>
        </b-collapse>
      </b-card>
      <b-card no-body class="topic">
        <b-card-header>
          <b-button v-b-toggle="'topic4'" block>
            <h1>{{ $t("martinelli.faq.q4") }}</h1>
            <i class="fas fa-chevron-down" />
            <i class="fas fa-chevron-up" />
          </b-button>
        </b-card-header>
        <b-collapse id="topic4">
          <p>
            {{ $t("martinelli.faq.a4") }}
          </p>
        </b-collapse>
      </b-card>
      <b-card no-body class="topic">
        <b-card-header>
          <b-button v-b-toggle="'topic5'" block>
            <h1>{{ $t("martinelli.faq.q5") }}</h1>
            <i class="fas fa-chevron-down" />
            <i class="fas fa-chevron-up" />
          </b-button>
        </b-card-header>
        <b-collapse id="topic5">
          <p>
            {{ $t("martinelli.faq.a5") }}
          </p>
        </b-collapse>
      </b-card>
    </section>
    <TheFooter class="vertical">
      <div class="footer-content">
        <h2 class="text-center align-self-center">
          {{ $t("martinelli.footer.title") }}
        </h2>
        <div>
          <h3>{{ $t("martinelli.footer.contact") }}</h3>
          <p class="text-secondary">
            Rua Coronel Santiago, 177 Anita Garibaldi, Joinville-SC |
            CEP:89203-560
          </p>
          <p class="text-secondary">CNPJ: 01.650.515/0001-08</p>
          <a class="blueColor" href="mailto:martinelli@martinelli.adv.br">
            <i class="far fa-envelope" />martinelli@martinelli.adv.br
          </a>
          <a class="blueColor" href="tel:+554721011800"
            ><i class="fas fa-phone" />(47) 2101-1800</a
          >
        </div>
        <b-navbar-nav class="footer-nav">
          <b-nav-item :to="followUpRoute">{{
            $t("home.btn.followup")
          }}</b-nav-item>
          <b-nav-item :to="'/' + Routes['report'][$i18n.locale]">{{
            $t("home.btn.report")
          }}</b-nav-item>
          <b-nav-item v-if="hasDocumentsSection" href="#leiturasImportantes">{{
            $t("martinelli.container.documents")
          }}</b-nav-item>
          <b-nav-item href="#ajuda">{{
            $t("martinelli.container.help")
          }}</b-nav-item>
        </b-navbar-nav>
      </div>
      <p class="copyright">{{ $t("martinelli.footer.copyright") }}</p>
    </TheFooter>
  </div>
</template>

<script>
import {
  Header as AppHeader,
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  Footer as TheFooter,
} from "@coreui/vue";

import { mapGetters } from "vuex";
import { Routes } from "@/i18n";
import { getRoutes } from "@/router";
import LanguageSwitcher from "@/components/LanguageSwitcher.vue";

export default {
  name: "MartinelliContainer",
  components: {
    AppHeader,
    AppSidebar,
    TheFooter,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    LanguageSwitcher,
  },
  data() {
    return {
      Routes,
      companyId: null,
      loading: false,
      minimized: false,
    };
  },
  computed: {
    ...mapGetters(["company", "portalBucket", "portal", "settings"]),
    routes() {
      return getRoutes();
    },
    name() {
      return this.$route.name;
    },
    hasMultiLanguageSupport() {
      if (!this.portal) return false;
      if (!this.portal.languages) return false;
      let multiLanguage =
        this.portal.languages.pt && this.portal.languages.pt.enabled;
      multiLanguage =
        multiLanguage &&
        ((this.portal.languages.en && this.portal.languages.en.enabled) ||
          (this.portal.languages.es && this.portal.languages.es.enabled));
      return multiLanguage;
    },
    hasDocumentsSection() {
      return Object.keys(this.company.compliance?.files || {}).length > 0;
    },
    layout() {
      return (
        this.$route?.meta?.layout || {
          sidebar: true,
        }
      );
    },
    logo() {
      return `https://${this.portalBucket}/${this.portal._id}/${this.portal?.logo}`;
    },
    adminUrl() {
      if (this.settings.whitelabel) {
        if (this.settings.whitelabel.portal) {
          return `https://${this.settings.whitelabel.portal}.${this.settings.whitelabel.fqdn}/admin`;
        } else {
          return `https://${this.settings.whitelabel.fqdn}/admin`;
        }
      }
      return "https://siscompliance.com.br/admin";
    },
    logoMinimized() {
      if (this.portal?.logoMinimized) {
        return `https://${this.portalBucket}/${this.portal._id}/${this.portal?.logoMinimized}`;
      }
      return null;
    },
    followUpRoute() {
      if (this.$route.name === "Home") {
        return "#consultar";
      }
      return "/" + Routes["follow-up"][this.$i18n.locale];
    },
    sidebarLinks() {
      const nav = [
        {
          name: this.$i18n.t(`router.Home`),
          url: "/",
          icon: "fas fa-home",
        },
        {
          name: this.$i18n.t("home.btn.followup"),
          url: this.followUpRoute,
          icon: "fas fa-eye",
        },
        {
          name: this.$i18n.t("home.btn.report"),
          url: "/" + Routes["report"][this.$i18n.locale],
          icon: "fas fa-file-alt",
        },
      ];

      const filesRoute = [];
      const compliance = this.company.compliance;
      if (compliance && (compliance.files || compliance.oldFiles)) {
        let files = compliance.files;
        const hasOldFiles = Object.keys(compliance.oldFiles || {}).length > 0;
        if (files.length > 0) {
          // handle new way of files
          for (const file of files) {
            filesRoute.push({
              name: file.name,
              url: `/download/${file._id}`,
            });
          }
        } else if (hasOldFiles) {
          let files = compliance.oldFiles;
          if (files.policy) {
            filesRoute.push({
              name: this.$i18n.t("router.Compliance"),
              url: `/download/policy`,
            });
          }
          if (files.ethicsConduct) {
            if (
              ["pvax-md-gusto", "grupogurgacz"].indexOf(this.portal.slug) !== -1
            ) {
              //FIXME
              filesRoute.push({
                name: this.$i18n.t("router.Code of Ethics"),
                url: "/open/ethicsConduct",
              });
            } else if (this.portal.slug === "maxicredito") {
              filesRoute.push({
                name: "Pacto de Ética", //FIXME
                url: `/download/ethicsConduct`,
              });
            } else {
              filesRoute.push({
                name: this.$i18n.t("router.Code of Ethics"),
                url: `/download/ethicsConduct`,
              });
            }
          }
          if (files.procedures) {
            filesRoute.push({
              name: this.$i18n.t("router.Channel Policy"),
              url: `/download/procedures`,
            });
          }
          if (files.committee) {
            filesRoute.push({
              name: this.$i18n.t("router.Committee"),
              url: `/download/committee`,
            });
          }
        }
      }
      if (filesRoute.length > 0) {
        nav.push({
          // title: true,
          name: this.$i18n.t("router.Information"),
          icon: "fas fa-building",
          children: filesRoute,
        });
      }
      return nav;
    },
  },
  async created() {
    this.companyId = window.location.pathname
      .replace("/portal/", "")
      .replace(/\/+/g, "");
    document.title = `${this.company.fantasyName} - Portal de Compliance`;
    let link = document.querySelector("link[rel~='icon']");
    if (!link && this.portal.favicon) {
      link = document.createElement("link");
      link.rel = "icon";
      link.href = `https://${this.portalBucket}/${this.portal._id}/${this.portal.favicon}`;
      document.head.appendChild(link);
    }
  },

  methods: {
    onMinimize(minimized) {
      this.minimized = minimized;
    },
  },
};
</script>
